import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import cn from 'classnames';
import { selectUserFilter, selectWebsiteUserFilter } from '../selectors';
import { UserSearchText } from './SearchText';
import { applyUserFilters, changeWebsiteUserFilter, resetUserFilters } from '../actions';
import { UserFilter } from './UserFilter';
import { COLOR_BG_LIGHT } from '../../../vars';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import { FiltersCloud } from './UserFiltersCloud';
import styles from './Search.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortAmountDown, faSortAmountUp } from '@fortawesome/free-solid-svg-icons';
import { WebsiteUsersMainFilterSection } from '../pages/website/websiteUsersMainFilterSection';

const Container = styled.div`
  float: left;
  width: 100%;
  background-color: white;
  margin-bottom: 12px;
  & * .Dropdown-root {
    width: 100%;
  }

  .filters-rows {
    gap: 12px;
    padding: 0px 24px 24px 24px;
    background-color: white;
    // margin-bottom: 22px;
    @media (max-width: 768px) {
      max-width: 100%;
      padding: 15px;
    }
  }

  .form-control {
    margin-bottom: 0;
  }

  .button {
    width: auto;
  }

  .all-filters-block {
    padding: 10px;
    background-color: ${COLOR_BG_LIGHT};
  }

  .button-filter {
    padding-right: ${props => props.width > 500 && '24px'};
    & * .button {
      margin: 0px;
      margin-left: 12px;
      background-color: white;
      color: #808c9c;
      border-radius: 8px 8px 0px 0px;
      box-shadow: 0 -2px 6px -1px #ececef;
      &:hover {
        background-color: #0183d5;
        color: #fff;
        box-shadow: none;
      }
    }
  }

  .row-1 {
    & * .decorated {
      width: 100%;
    }
  }

  .grid-column {
  }

  .grid-row-long {
    flex-basis: ${props => (props.width <= 1520 ? '100%' : '49%')};
  }
  .grid-row-short {
    border: 1px solid #cccccc;
    border-radius: 3px;
    width: 49%;
    & > .button {
      margin: 0px;
    }
  }

  .tablet-row {
    margin-bottom: 22px;
  }

  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .button-block {
    & * .button {
      margin: 0px;
    }
  }
  .input-element {
    font-size: 13px;
    height: 45px;
  }
`;

const ShowAllButton = styled.span`
  color: grey !important;
  font-size: 14px;
  color: #0083d5;
  cursor: pointer;
`;

const STATUS_FILTER_VALUE = {
  0: 'ACTIVE',
  1: 'DELETED',
};

const STATE = {
  showAllFilters: false,
  filterToReset: null,
  isFilterMenuOpen: false,
};

/* eslint-disable react/prefer-stateless-function */
class UserSearchComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  get statuses() {
    let statuses = _.times(2, n => {
      return this.lblStr(`user.property.status.${n}`);
    })?.map((s, i) => ({ label: `${s}`, value: STATUS_FILTER_VALUE[i] }));

    return statuses;
  }

  onSelectMainFilter(filterName) {
    if (filterName === this.selectedMainFilter) {
      this.props.changeWebsiteFilter('mainFilter', null);
      return;
    }
    this.props.changeWebsiteFilter('mainFilter', filterName);
  }

  get selectedMainFilter() {
    return this.props?.websiteFilter?.mainFilter ?? null;
  }

  toggleFilterMenu = () => {
    this.setState(state => ({
      isFilterMenuOpen: !state.isFilterMenuOpen,
      showAllFilters: state.showAllFilters ? false : state.showAllFilters,
    }));
  };

  render() {
    if (!this.props.filter) return null;
    const STATUSES = this.statuses;
    return (
      <Container width={window.innerWidth}>
        <div className="container-fluid p-0">
          <div className="container-fluid ps-0 pe-0 pt-3 pb-0">
            <div className="row p-0 m-0 align-items-center">
              {window.innerWidth > 768 && (
                <div className="col-7 col-sm-8 mb-3 col-md-12 col-lg-12 col-xl-12 col-xxl-6">
                  <UserSearchText filter={this.props.filter} mediumWide />
                </div>
              )}
              {window.innerWidth <= 768 && (
                <>
                  <UserSearchText filter={this.props.filter} mediumWide />
                  <ButtonComponent style={'ButtonSoftPrimarySearch'} onClick={() => this.props.applyFilters()}>
                    {this.lblStr('vehicle.filter.apply')}
                  </ButtonComponent>
                  <div
                    className={cn('col-5 mb-3 col-sm-2 col-md-3 col-lg-2 col-xl-2 p-0 text-end', styles.buttonContainer)}
                  ></div>
                  <div className={cn('col-12 mb-3 col-sm-2 p-0 text-end', styles.buttonFilterContainer)}>
                    <ButtonComponent style={'ButtonSoftEdit'} onClick={this.toggleFilterMenu}>
                      {this.lbl('vehicle.overview.filter')}
                      {this.state.isFilterMenuOpen ? (
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      ) : (
                        <FontAwesomeIcon icon={faSortAmountDown} />
                      )}
                    </ButtonComponent>
                  </div>
                </>
              )}
            </div>
          </div>
          {(window.innerWidth > 768 || this.state.isFilterMenuOpen) && (
            <div className="container-fluid pt-0">
              <div className="row">
                {' '}
                <div className="col-12 mb-3 col-lg-6 mb-3 col-xl-6 col-xxl-3 mb-3">
                  <UserFilter name="company" type="multiple" search="company" className="red-text" minWidth={'100%'} />
                </div>
                <div className="col-12 mb-3 col-lg-6 mb-3 col-xl-6 col-xxl-3 mb-3">
                  <UserFilter minWidth={'100%'} name="status" type="single" options={STATUSES} noModify namedFilter />
                </div>
                <div className="col-12 mb-3 col-lg-6 mb-3 col-xl-6 col-xxl-3 mb-3">
                  <WebsiteUsersMainFilterSection
                    selected={this.selectedMainFilter}
                    onSelect={this.onSelectMainFilter.bind(this)}
                    renderDropdownFilters
                  />
                </div>
              </div>
            </div>
          )}
          <div className="row p-0 mt-2">
            {(window.innerWidth > 768 || this.state.isFilterMenuOpen) && (
              <>
                <div className="col-12 mb-3">
                  <FiltersCloud />
                </div>
              </>
            )}
          </div>
          <div className={cn('col-12 mb-3 col-sm-12 mb-3 col-lg-5 mb-3 col-xl-6 mb-3 text-end', styles.container)}>
            <div className={styles.buttonShowAll}>
              <ButtonComponent style={'ButtonSoftDelete'} onClick={this.props.reset}>
                {this.lblStr('invoice.filter.clearAll')}
              </ButtonComponent>
              <ButtonComponent style={'ButtonSoftEdit'} onClick={() => this.props.applyFilters()}>
                {this.lblStr('vehicle.filter.apply')}
              </ButtonComponent>
            </div>
          </div>
        </div>
      </Container>
    );
  }
}

UserSearchComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    filter: selectUserFilter(),
    websiteFilter: selectWebsiteUserFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    reset() {
      dispatch(resetUserFilters());
    },
    applyFilters() {
      dispatch(applyUserFilters());
    },
    changeWebsiteFilter(key, value) {
      dispatch(changeWebsiteUserFilter(key, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const UserSearch = compose(withConnect, withRouter, injectIntl)(UserSearchComp);
